import { IconButton, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { MdDelete } from "react-icons/md";

function SingleFaq({ question, answer, onChange, onDelete }) {
  const [data, setData] = useState({ question, answer });
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <div className="flex flex-col w-full border-2 border-dotted border-gray-400 rounded-md relative">
      <div className="absolute right-0 bottom-0 translate-x-3 translate-y-3 bg-primary rounded-full z-10">
        <IconButton size="small" sx={{ opacity: 1 }} onClick={onDelete}>
          <MdDelete color="white" />
        </IconButton>
      </div>
      <TextField
        label="Question"
        variant="filled"
        size="small"
        fullWidth
        className="col-span-2"
        value={data.question}
        onChange={handleChange}
        name="question"
      />

      <TextField
        label="Answer"
        variant="filled"
        size="small"
        className="col-span-2"
        fullWidth
        value={data.answer}
        onChange={handleChange}
        name="answer"
      />
    </div>
  );
}

export default SingleFaq;
